module.exports = __webpack_public_path__ + "img/2.06c5855d.webp";